import { render, staticRenderFns } from "./PlateSearchHistoryDialog.vue?vue&type=template&id=75c546ec"
import script from "./PlateSearchHistoryDialog.vue?vue&type=script&lang=js"
export * from "./PlateSearchHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports